var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "600px",
        transition: "dialog-bottom-transition",
        persistent: ""
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
            [
              _c("div", { staticClass: "divP", attrs: { align: "left" } }, [
                _c("p", { staticClass: "aclaracion" }, [
                  _c("br"),
                  _vm._v(
                    "\n          Por favor, asegurece de ingresar un archivo en formato .CSV.\n        "
                  )
                ])
              ])
            ]
          ),
          _c("v-divider"),
          _c("br"),
          _c(
            "v-form",
            {
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "FormFieldsContainer",
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.archivo.label,
                          heigh: "",
                          "error-messages": _vm.errors.collect("archivo"),
                          readonly: "readonly",
                          clearable: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.$refs.image.click()
                          },
                          "click:clear": function($event) {
                            return _vm.eliminarNombre()
                          }
                        },
                        model: {
                          value: _vm.formFields.archivo.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.archivo, "value", $$v)
                          },
                          expression: "formFields.archivo.value"
                        }
                      }),
                      _c("input", {
                        key: _vm.idkey,
                        ref: "image",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept: ".csv",
                          id: "archivoExcel"
                        },
                        on: { change: _vm.cargarNombre }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs6: "", sm6: "", md7: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md5: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          attrs: { disabled: false },
                          on: {
                            click: function($event) {
                              return _vm.subirExcel()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }